module.exports = __webpack_public_path__ + "master-logo.ab3a9361.svg";